import i18next, { i18n } from 'i18next'
//todo: use typescript files instead and have an enum based on the keys of that object
import translations_en from './en/translations.json'
import translations_fr from './fr/translations.json'
import { initReactI18next } from 'react-i18next'

export enum Language {
  en = 'en',
  fr = 'fr',
}

export const resources = {
  [Language.en]: {
    translation: translations_en,
  },
  [Language.fr]: {
    translation: translations_fr,
  },
} as const

export const initTranslation = (lng = Language.en): i18n => {
  i18next.use(initReactI18next).init({
    fallbackLng: Language.en,
    preload: [Language.en],
    keySeparator: false,
    nsSeparator: false,
    lng,
    ns: ['translation'],
    resources,
  })

  return i18next
}
